import React from 'react'
import { normalizePoints, toSmoothPath, toSmoothAreaPath } from '../lib/charts'

interface Props {
  data: number[]
  color?: string
  type?: 'line' | 'area'
  width?: number
  height?: number
}

export default function Sparkline({
  data,
  color = 'var(--accent)',
  type = 'line',
  width = 80,
  height = 24,
}: Props) {
  if (data.length === 0) return <svg width={width} height={height} />

  const pts = normalizePoints(data, width, height)
  const linePath = toSmoothPath(pts)
  const areaPath = type === 'area' ? toSmoothAreaPath(pts, height) : ''
  const last = pts[pts.length - 1]

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={{ display: 'block', overflow: 'visible' }}
      aria-hidden="true"
    >
      {type === 'area' && (
        <path
          d={areaPath}
          fill={color}
          fillOpacity={0.12}
          stroke="none"
        />
      )}
      <path
        d={linePath}
        fill="none"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {last && (
        <circle
          cx={last.x}
          cy={last.y}
          r={2}
          fill={color}
        />
      )}
    </svg>
  )
}
